import React, {useEffect} from 'react'
import {useSelector} from 'react-redux'
import RenderedHtmlContent from "src/shared/virtual_congress/components/rendered_html_content";
import useLiquid from 'src/shared/service/use_liquid'

const ClosedPage = () => {
  const tagOwner = useSelector(state => state.tagOwner)
  const footerText = useSelector(state => state.footerText).trim()
  const closedHeadline = useSelector(state => state.closedHeadline).trim()
  const closedText = useSelector(state => state.closedText).trim()
  const closedRedirectEnabled = useSelector(state => state.closed_redirect_enabled)
  const closedRedirectUrl = useSelector(state => state.closed_redirect_url)
  const closedRedirectDelay = useSelector(state => state.closed_redirect_delay)
  const renderLiquid = useLiquid()

  useEffect(() => {
    let redirectTimeout = null

    if (closedRedirectEnabled && closedRedirectUrl){
      const parsedClosedRedirectUrl = renderLiquid(closedRedirectUrl.replace("@tag_owner_id@", tagOwner?.id))

      if (closedRedirectDelay && closedRedirectDelay >= 0) {
        redirectTimeout = setTimeout(function () {
          window.location = parsedClosedRedirectUrl;
        }, closedRedirectDelay)
      } else {
        window.location = parsedClosedRedirectUrl;
      }
    }

    return () => {
      if (redirectTimeout) {
        clearTimeout(redirectTimeout)
      }
    }
  }, [closedRedirectEnabled, closedRedirectUrl, tagOwner, renderLiquid])
  
  return (
    <div className="r-container row">
      <div className="col">
        <div className="closed">
          <div className="r-header-text">
            <RenderedHtmlContent html={closedText.replace(/@tag_owner_id@/g, tagOwner?.id)}/>
          </div>
        </div>
        <div className="r-footer">
          <div className="r-footer-text">
            <RenderedHtmlContent  html={footerText}/>
          </div>
        </div>
      </div>
    </div>
  )
}
export default ClosedPage;